// src/pages/MyItems.js
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { getWorkerInventory } from '../services/api';
import { formatDistanceToNow } from 'date-fns';

export default function MyItems() {
  const { worker } = useContext(AuthContext);
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getWorkerInventory(worker.worker_id)
      .then(res => setItems(res.data.items || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [worker]);

  if (loading) return (
    <div className="screen theme-light">
      <div className="loading"><div className="spinner" /><span>Loading your items...</span></div>
    </div>
  );

  return (
    <div className="screen theme-light">
      <div className="screen-header">
        <h2>My Items</h2>
        <span style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.85rem' }}>{items.length} items</span>
      </div>
      <div className="screen-content">
        {items.length === 0 ? (
          <div className="empty-state">
            <div style={{ fontSize: '3rem' }}>📦</div>
            <h3>Nothing checked out</h3>
            <p>Items you check out will appear here</p>
            <button className="btn btn-primary" style={{ marginTop: 16, maxWidth: 200 }} onClick={() => navigate('/scan')}>
              Scan a Tool
            </button>
          </div>
        ) : (
          <div className="card">
            {items.map(item => (
              <div key={item.item_id} className="item-row" onClick={() => navigate(`/item/${item.item_id}`)}>
                <div className="item-row-icon">🔧</div>
                <div className="item-row-info">
                  <h4>{item.name}</h4>
                  <p>{item.asset_tag} · {item.category}</p>
                  <p style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>
                    Checked out {item.checked_out_at ? formatDistanceToNow(new Date(item.checked_out_at), { addSuffix: true }) : ''}
                  </p>
                  {item.requester_name && (
                    <div style={{ marginTop: 4 }}>
                      <span style={{
                        fontSize: '0.68rem', fontWeight: 700, color: '#92400e',
                        background: '#fef3c7', border: '1px solid #f59e0b',
                        borderRadius: 4, padding: '1px 6px', display: 'inline-block'
                      }}>
                        Requested by {item.requester_name}
                      </span>
                      {item.for_location && (
                        <p style={{ fontSize: '0.68rem', color: '#d97706', margin: '2px 0 0' }}>
                          For: {item.for_location}
                        </p>
                      )}
                    </div>
                  )}
                </div>
                <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                </svg>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}